import { render } from "./Hombre.vue?vue&type=template&id=978b6264"
import script from "./Hombre.vue?vue&type=script&lang=js"
export * from "./Hombre.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__